import { findCachedEntity } from '@src/store/contentEntities/contentEntities';
import type { ContentEntityType } from '@src/store/contentEntities/model';
import { jotaiStore } from '@src/store/store';
import { reactionsAtom } from '../reactions';

export const getContentEntityReactionCount = (type: ContentEntityType, entitiyId: string, reactionName: string) => {
    const item = findCachedEntity(type, entitiyId);
    return item?.reactionsCount?.[reactionName] ?? 0;
};

// Helper atom to get a single reaction by composite key (read-only)
export const findUserReactionOnContentEntity = (entityType: ContentEntityType, entityId: string, reactionName: string, userId: string) => {
    const reactions = jotaiStore.get(reactionsAtom);
    const reaction = reactions[userId]; // userId is the reaction ID

    return reaction?.entityType === entityType && reaction?.entityId === entityId && reaction?.reactionName === reactionName ? reaction : undefined;
};

export const getReactionById = (id: string) => {
    const reactions = jotaiStore.get(reactionsAtom);
    return reactions[id];
};

export function generateReactionId(userId: string, entityType: ContentEntityType, entityId: string) {
    return `${userId}-${entityType}-${entityId}`;
}
